import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import { StyledColumn, StyledRow, LeaseSummaryColumnContent } from '../common/LeaseStyles';

const LeaseSummaryColumnTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 22px;
`;

const LeaseSummaryColumnContentListItem = styled.div`
  font-style: normal;
`;

export default function ResidentDetails({ leaseDetails }) {
  return (
    <>
      <StyledRow>
        <StyledColumn md={8}>
          <LeaseSummaryColumnTitle>
            {getTranslatedString(
              'landlordPortal.leaseCreatorV2.leaseSummaryPage.residentDetails.applicants'
            )}
          </LeaseSummaryColumnTitle>

          <LeaseSummaryColumnContent>{leaseDetails.main_tenant_name}</LeaseSummaryColumnContent>
        </StyledColumn>
        <StyledColumn md={8}>
          <LeaseSummaryColumnTitle>
            {getTranslatedString(
              'landlordPortal.leaseCreatorV2.leaseSummaryPage.residentDetails.occupants'
            )}
          </LeaseSummaryColumnTitle>

          <LeaseSummaryColumnContent>
            {leaseDetails.cotenants_names.length > 0 &&
              leaseDetails.cotenants_names.map((name, index) => (
                <LeaseSummaryColumnContentListItem key={index}>
                  {name}
                </LeaseSummaryColumnContentListItem>
              ))}
          </LeaseSummaryColumnContent>
        </StyledColumn>
      </StyledRow>
    </>
  );
}
